import React from 'react'

const Restricted = ({ width = 18, height = 18, fill = 'var(--ds-gray-5)', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M9.00293 1.28613C11.3867 1.28613 13.327 3.05274 13.3271 5.22461V6.94043H13.7324C14.6703 6.9405 15.4285 7.65363 15.4287 8.52734V15.127C15.4287 16.0008 14.664 16.7138 13.7324 16.7139H4.26758C3.32954 16.7138 2.57129 16.0008 2.57129 15.127V8.52734C2.57149 7.65363 3.33609 6.9405 4.26758 6.94043H4.67871V5.22461C4.67882 3.05282 6.61932 1.28627 9.00293 1.28613ZM4.27441 8.21973C4.04953 8.21973 3.86328 8.36084 3.86328 8.52148V15.1211C3.86361 15.288 4.05614 15.4229 4.27441 15.4229H13.7383C13.963 15.4229 14.1501 15.2816 14.1504 15.1211V8.52148C14.1504 8.35441 13.9567 8.21973 13.7383 8.21973H4.27441ZM9.00977 10.2373C9.36334 10.2373 9.65234 10.5265 9.65234 10.8799V12.7627C9.65216 13.116 9.36322 13.4053 9.00977 13.4053C8.65639 13.4052 8.36737 13.1159 8.36719 12.7627V10.8799C8.36719 10.5265 8.65628 10.2374 9.00977 10.2373ZM9.00977 2.57129C7.33282 2.57129 5.97081 3.75959 5.9707 5.22461H5.97656V6.94043H12.0488V5.22461C12.0487 3.75962 10.6867 2.57135 9.00977 2.57129Z"
      fill={fill}
    />
  </svg>
)

export default Restricted
